module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/9b85cf9c2bc497405a1baff3ce49ddbc.svg";